import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  GET_REGISTER_CLOSURE_LIST,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  RegisterClosuresData: [],
  successMessage: "",
  error: "",
};

let abortRegisterClosure = null;

export const fetchRegisterClosuresData = createAsyncThunk(
  "RegisterClosuresSlice/fetchRegisterClosuresData",
  async (data, { rejectWithValue }) => {
    try {
      if (abortRegisterClosure) {
        abortRegisterClosure.abort();
      }

      abortRegisterClosure = new AbortController();
      const signal = abortRegisterClosure.signal;

      const { token, ...dataNew } = data;

      const response = await axios.post(
        BASE_URL + GET_REGISTER_CLOSURE_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      if (response.data.length > 0) {
        const arr = response.data;
        const status = true;
        return { arr, status };
      } else {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      return rejectWithValue(toThunkRejectValue(error));
    }
  }
);

const RegisterClosuresSlice = createSlice({
  name: "RegisterClosuresSlice",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRegisterClosuresData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRegisterClosuresData.fulfilled, (state, action) => {
      state.loading = false;
      state.RegisterClosuresData = action.payload.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchRegisterClosuresData.rejected, (state, action) => {
      state.loading = false;
      // Aborted superseding request — keep existing rows, don't flash empty/error.
      if (
        action.payload?.status === "canceled" ||
        action.payload?.message === "canceled"
      ) {
        return;
      }
      state.RegisterClosuresData = [];
      state.error = action.error.message;
    });
  },
});

export default RegisterClosuresSlice.reducer;
